import { Dispatch } from "redux";
import {
    ChangeCollectorAction,
    ChangeEffectiveDateAction,
    ChangeRouteNameAction,
    ChangeRouteRemark,
    ChangeRouteTimeEndTimeAction,
    ChangeRouteTimeStartTimeAction,
    ChangeWorkingDate,
    ClearRouteFormDataAction,
    GetDataFromRouteListAction,
    RouteAction,
    SelectBinInfosAction,
    initCollectRouteListAction,
    initCollectorAction,
    initRouteListAction,
} from "./action";
import { CollectorInfo, RouteCollectionInfo, RouteState } from "./state";
import { MultiValue } from "react-select";
import { BinInfo } from "../staticInfo/state";
import { Day } from "../../interface/form";
import { ConvertWeekDayToNumber } from "../../util/date";

export function initCollectorListThunk(collectorList: CollectorInfo[]) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(initCollectorAction(collectorList));
    };
}

export function selectedBinInfosThunk(selectedBinInfo: MultiValue<BinInfo>) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(SelectBinInfosAction(selectedBinInfo));
    };
}

export function handleDropDownThunk(
    draggedIndex: number,
    selectedBinInfo: MultiValue<BinInfo>,
    index: number
) {
    const newSelectedBinInfo = Array.from(selectedBinInfo!);
    const [removed] = newSelectedBinInfo.splice(draggedIndex, 1);
    newSelectedBinInfo.splice(index, 0, removed);
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(SelectBinInfosAction(newSelectedBinInfo));
    };
}

export function ChangeRouteNameThunk(routeName: string) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(ChangeRouteNameAction(routeName));
    };
}

export function SelectCollectorThunk(collector_id: string) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(ChangeCollectorAction(collector_id));
    };
}

export function ChangeRouteRemarkThunk(remark: string) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(ChangeRouteRemark(remark));
    };
}

export function ChangeEffectiveDateThunk(date: Date) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(ChangeEffectiveDateAction(date));
    };
}

export function ClearRouteFormDataThunk() {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(ClearRouteFormDataAction());
    };
}

export function initRouteListThunk(routeList: RouteState[]) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(initRouteListAction(routeList));
    };
}

export function GetDataFromRouteListThunk(routeData: RouteState,routeList:MultiValue<BinInfo> ) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(GetDataFromRouteListAction(routeData,routeList));
    };
}

export function initCollectRouteListThunk(
    RouteCollectionList: RouteCollectionInfo[]
) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(initCollectRouteListAction(RouteCollectionList));
    };
}

export function SelectWorkingDateThunk(weekday: string) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(ChangeWorkingDate(weekday));
    };
}

export function changeStartingTimeThunk(start_time: string, index: number) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(ChangeRouteTimeStartTimeAction(start_time, index));
    };
}

export function ChangingEndTimeThunk(end_time: string, index: number) {
    return (dispatch: Dispatch<RouteAction>) => {
        dispatch(ChangeRouteTimeEndTimeAction(end_time, index));
    };
}
